// Allowed user/registration positions. Single frontend source of truth for the
// Position dropdowns; kept in sync with the users_position_check /
// registration_queue_position_check DB constraints (see migration
// 20260528020000_expand_positions.sql). Adding a position = edit here + a
// matching migration.
export const POSITIONS = [
  'Country Manager',
  'BD Executive',
  'BD Manager',
  'Auditor',
  'BOD',
];
